@reference "../styles/ui.css";

.slide-out {
  @apply shadow-lg;
}

.slide-out :global(.slide-out-footer),
.slide-out :global(.slide-out-header) {
  @apply flex gap-3 items-center px-6 py-4 bg-hsp-500 text-white;
}

.slide-out :global(.slide-out-header .icon) {
  @apply flex items-center justify-center;
}

.slide-out :global(.slide-out-header button.close-button) {
  position: initial;
  @apply flex items-center justify-center;
}
